
function TextMonoToken({ ...props }) {
    return (<span className="font-mono slashed-zero tabular-nums tracking-widest" {...props}>{props.children}</span>);
}

export { TextMonoToken }